import React from "react";
import styled from "styled-components";

import { Container } from "@util/standard";
import { assets, colors } from "@util/constants";
import { Image } from "@global";

interface Props {
  width?: string;
  height?: string;
  altText?: string;
}

const PlaceholderContainter = styled(Container)`
  background: #F1F1F1;
  align-item: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  border-radius: 5px;
  padding: 20px;
  img{
    width: 60px;
    height: auto;
    opacity: 0.3;
  }
`;

const PlaceholderImage = (props: Props) => {
  return (
    <PlaceholderContainter {...props}>
      <Image
        staticImage={assets.placeholder}
        width="100%"
        height="100%"
        altText={props.altText ?? "Everyday by Barker's"} />
    </PlaceholderContainter>
  );
};

export default PlaceholderImage;
